import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  HostListener,
  EventEmitter,
  ElementRef
} from '@angular/core';
import { trigger, state, style, transition, animate, AnimationEvent } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import {LogOut} from '4sure-identity';
import { switchMap } from 'rxjs/operators';
import { CoreServices } from '4sure-wilo';

const ESCAPE = 27;
const ANIMATION_TIMINGS = '400ms cubic-bezier(0.25, 0.8, 0.25, 1)';

@Component({
  selector: 'flx-app-menu',
  templateUrl: 'app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideContent', [
      state('void', style({ transform: 'translate3d(-25% ,0,0)', opacity: 0 })),
      state('enter', style({ transform: 'none', opacity: 1 })),
      state('leave', style({ transform: 'translate3d(-25%, 0,0)', opacity: 0 })),
      transition('* => *', animate(ANIMATION_TIMINGS))
    ])
  ]
})
export class FLXAppMenuComponent implements OnInit {
  @Input() opened = true;
  version!: string;
  currentUser$!: Observable<any>;
  themeCheckedStatus!: boolean;
  theme = '';
  navItems!: any;
  logo_url!: any;
  logoutIcon = 'app-menu-logout';
  animationState: 'void' | 'enter' | 'leave' = 'enter';
  animationStateChanged = new EventEmitter<AnimationEvent>();
  navItems$!: Observable<any>;
  appMenuRef!: any;


  @HostListener('document:click', ['$event.target'])
  listenToClickOutsideMenu(target: any) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    const hamburgerEl = document.getElementById('hamburger-menu');
    const notHamburgerEl = target.id !== hamburgerEl?.id;
    if (!clickedInside && notHamburgerEl) {
      const appMenuRef = this.svc.keyValueStore.getItem('appMenuRef');
      this.svc.obsKeyValueStore.setItem('openAppMenu',false);
      appMenuRef.close();
    }
  }

  // @HostListener('document:keydown', ['$event']) private handleKeyDown(event: KeyboardEvent) {
  //   const key = event.key;
  //   if (key === 'Escape') {
  //     this.appMenuOverlayService.appMenuRef.close();
  //   }
  // }

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private _store: Store<any>,
    private svc: CoreServices,
    private route: ActivatedRoute
    // private navService: NavService,
    // private bf: BigFormService
  ) {}

  ngOnInit() {
    this.currentUser$ = this.svc.auth.getUser();
    this.navItems$ = this.svc.configAccessor.currentApp$.pipe(switchMap(app => app && app.appMenu ? app.appMenu(this.svc, this.route) : of([])));
    // this.version = environment.version;

    // if (environment.branding) {
    //   this.logo_url = environment.branding.logo_url;
    // }

    // this._store
    //   .select(getActiveTheme)
    //   .pipe(take(1))
    //   .subscribe(value => {
    //     this.theme = value;
    //     // This should be done better. Need to look at making
    //     // more flexible in the future
    //     switch (value) {
    //       case 'midday':
    //         this.themeCheckedStatus = true;
    //         break;
    //       case 'blackout':
    //         this.themeCheckedStatus = false;
    //         break;
    //       default:
    //         this.themeCheckedStatus = false;
    //         break;
    //     }
    //   });
  }


  redirect(navItem: any) {
    this.svc.router.navigate([navItem.routerLink]);
    if (!this.appMenuRef) {
      this.appMenuRef = this.svc.keyValueStore.getItem('appMenuRef');
    }
    this.appMenuRef.close();
  }

  toggleEditable(event: any) {
    // if (event.target.checked) {
    //   this._store.dispatch(new SetTheme({ name: 'midday' }));
    // } else {
    //   this._store.dispatch(new SetTheme({ name: 'blackout' }));
    // }
  }

  signout(event: any) {
    // event.preventDefault();
    // this.navService.portalActions.next({ call: '', paramFunc: () => {} });
    this._store.dispatch(new LogOut());
    // this.cdr.detectChanges();
  }

  onAnimationStart(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  onAnimationDone(event: AnimationEvent) {
    this.animationStateChanged.emit(event);
  }

  startExitAnimation() {
    this.animationState = 'leave';
  }
}
